export default "__VITE_ASSET__Br6My4an__"